/**
 * 闭包函数
 *
 * 防抖：对于短时间内连续触发的事件（滚动事件、表单重复提交、页面resize事件，常见于需要做页面适配的时候），让某个时间期限内，事件处理函数只执行一次。
 * 节流：对于短时间内大量触发同一事件（滚动事件、输入框实时搜索），那么在函数执行一次之后，该函数在指定的时间期限内不再工作，直至过了这段时间才重新生效
 */
// 防抖
let timeout = null
const debounce = (fun, time = 500) => {
  if (timeout) {
    clearTimeout(timeout) // 规定时间内若定时器存在则清除
  }
  timeout = setTimeout(() => {
    // fun() // 调用接口
    fun.call(this, ...arguments) // 调用接口
  }, time)
}
// 节流
let flag = true
const throttle = (fun, time = 500) => {
  if (flag) {
    setTimeout(() => {
      fun() // 调用接口
      flag = true // 在定时器执行后 移除if阻断
    }, time)
  }
  flag = false // 在执行一次后 if阻断定时器继续执行
}
export default {
  debounce,
  throttle
}
export { debounce, throttle }
